import React from 'react'
import {
  Typography,
  IconDoneCheck,
  Box,
} from '@creditas-ui/react'
import { CardHeaderResumeHomeFin } from '../CardHeaderResume'
import { CardResumeFeedStyle, FeedDescription } from './CardResumeFeed.styles'

const CardResumeFeedHomeFin = ({ lead }) => {
  return (
    <CardResumeFeedStyle {...lead}>
      <CardHeaderResumeHomeFin
        lastUpdate={lead?.lastUpdateDate ?? lead?.creationdate}
      />
      {lead?.lastUpdateDescription && (
        <Box display="flex" spaceX="12px" pt="16px">
          <IconDoneCheck strokeWidth={0.5} size={24} />
          <Box spaceY="8px" width="100%">
            <Typography color="neutral.90" component="h2" variant="bodyMdBold">
              Último registro de atendimento
            </Typography>
            <FeedDescription
              color="neutral.90"
              component="p"
              variant="bodySmLight"
              style={{ wordBreak: 'break-word' }}
              dangerouslySetInnerHTML={{
                __html: lead?.lastUpdateDescription,
              }}
            />
          </Box>
        </Box>
      )}
    </CardResumeFeedStyle>
  )
}

export { CardResumeFeedHomeFin }
